import type { SettingsFlow, UpdateSettingsFlowBody } from "@ory/kratos-client";
import type React from "react";
import { Flow } from "~/components/KratosFlow";

interface Props {
	flow: SettingsFlow;
	onSubmit: (values: UpdateSettingsFlowBody) => Promise<void>;
}

export const LookupSecretSettings: React.FC<Props> = ({ flow, onSubmit }) => {
	return (
		<Flow
			onSubmit={onSubmit}
			flow={flow}
			only="lookup_secret"
			setLabelTypes={[
				{
					query: { name: "lookup_secret_regenerate", type: "submit" },
					value: "error",
				},
				{
					query: { name: "lookup_secret_disable", type: "submit" },
					value: "error",
				},
			]}
			sortComponents={[
				{ name: "lookup_secret_reveal" },
				{ id: "lookup_secret_codes" },
				{ name: "lookup_secret_regenerate" },
				{ name: "lookup_secret_disable" },
			]}
		/>
	);
};
